import { render, staticRenderFns } from "./PessoaSelect.vue?vue&type=template&id=321153bd&"
import script from "./PessoaSelect.vue?vue&type=script&lang=js&"
export * from "./PessoaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports